import { Menu } from '@base-ui/react/menu'
import { twMerge } from 'tailwind-merge'
import type { PartProps } from '../../../lib/part-props'

/**
 * Props interface for MenuPositioner component.
 * Extends base-ui's Menu.Positioner.Props for positioning options.
 */
interface MenuPositionerProps extends PartProps<Menu.Positioner.Props> {
  className?: string
}

/**
 * MenuPositioner - Positions the menu popup relative to the trigger.
 *
 * This component handles the positioning logic for the menu popup,
 * including collision detection and alignment with the trigger element.
 *
 * Default positioning:
 * - sideOffset: 8px (gap between trigger and popup)
 * - Automatic collision avoidance
 *
 * @example
 * ```tsx
 * <Menu.Positioner sideOffset={8} side="bottom">
 *   <Menu.Popup>
 *     {/* Menu content *\/}
 *   </Menu.Popup>
 * </Menu.Positioner>
 * ```
 */
function MenuPositioner({ className, children, sideOffset = 4, ...props }: MenuPositionerProps) {
  return (
    <Menu.Positioner className={twMerge('z-50 outline-none', className)} sideOffset={sideOffset} {...props}>
      {children}
    </Menu.Positioner>
  )
}

export { MenuPositioner }
